import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

export function Informations() {
  return (
    <div className="w-full mx-auto sm:w-full flex flex-col gap-2">
      <Card>
        <CardHeader>
          <CardTitle className="uppercase text-muted-foreground font-bold">Canais de atendimento</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-4">
            <div className="flex flex-col gap-2 shadow p-3 rounded-lg">
              <h2 className="font-bold text-sm text-muted-foreground">Vendas</h2>
              <p className="text-sm text-muted-foreground">Canal exclusivo de vendas (21) 3962-2740.</p>
            </div>
            <div className="flex flex-col gap-2 shadow p-3 rounded-lg">
              <h2 className="font-bold text-sm text-muted-foreground">Suporte 24h</h2>
              <p className="text-sm text-muted-foreground">Central de atendimento 24h (21) 2762-5350.</p>
            </div>
            <div className="flex flex-col gap-2 shadow p-3 rounded-lg">
              <h2 className="font-bold text-sm text-muted-foreground">Baixada Fluminense</h2>
              <p className="text-sm text-muted-foreground">Atuação em Belford Roxo, Magé e Duque de Caxias.</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="w-full">
        <CardHeader>
          <CardTitle className="uppercase text-muted-foreground font-bold">Como funciona?</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-4">
            <div className="flex flex-col gap-2 shadow p-3 rounded-lg">
              <h1 className="font-bold text-sm text-muted-foreground">1) Envie seus dados</h1>
              <p className="text-sm text-muted-foreground">Nome, CPF e número do celular para contato.</p>
            </div>
            <div className="flex flex-col gap-2 shadow p-3 rounded-lg">
              <h1 className="font-bold text-sm text-muted-foreground">2) Verificação</h1>
              <p className="text-sm text-muted-foreground">Confirmaremos a cobertura e tiraremos todas as dúvidas.</p>
            </div>
            <div className="flex flex-col gap-2 shadow p-3 rounded-lg">
              <h1 className="font-bold text-sm text-muted-foreground">3) Ativação</h1>
              <p className="text-sm text-muted-foreground">Agendamos a instalação com você.</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <div className="border rounded-lg p-5 shadow">
        <p className="text-sm text-muted-foreground">Indique também pelo telefone <b>(21) 2762-5350</b> ou pelo <b><a href="https://wa.me/552127625350?text=Ol%C3%A1%2C%20quero%20fazer%20uma%20indica%C3%A7%C3%A3o." className="text-green-500">WhatsApp</a></b>.</p>
      </div>
    </div>
  );
}